import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import AutorenewOutlinedIcon from '@material-ui/icons/AutorenewOutlined';
import FormatQuote from '@material-ui/icons/FormatQuote';
import Star from '@material-ui/icons/Star';
import { Box, Button, Typography } from '@material-ui/core';
import { MORTAGAGE_FLOW_OPTIONS } from 'presenters/MortgageSurveyQuestionPresenter';

import useStyles from './useStyles';

const MortgageSurveyFlowSelect = props => {
  const { t } = useTranslation();
  const { onSelect, rowComponent, removeQuoteBox } = props;
  const classes = useStyles();

  const handleSelect = value => () => onSelect(value);

  return (
    <Box>
      {rowComponent}
      <Box mt={4} />
      <Box display="flex" width="100%" my={3} flexWrap="wrap" justifyContent="center" alignContent="space-around">
        {MORTAGAGE_FLOW_OPTIONS.map(({ label, value }) => {
          const Icon = value === 'purchase' ? HomeOutlinedIcon : AutorenewOutlinedIcon;
          return (
            <Button key={value} onClick={handleSelect(value)} className={clsx(classes.button)} startIcon={<Icon />}>
              {label}
            </Button>
          );
        })}
      </Box>
      {!removeQuoteBox && (
        <div>
          <Box className={classes.starContainer}>
            <Star className={classes.star} />
            <Star className={classes.star} />
            <Star className={classes.star} />
            <Star className={classes.star} />
            <Star className={classes.star} />
          </Box>
          <Typography variant="body1" className={classes.starDesc} align="center">
            {t('sharedComponents.MortgageSurveyFlowSelect.starDescription')}
            <br />
            {t('sharedComponents.MortgageSurveyFlowSelect.starDescription2')}
          </Typography>

          <Box className={classes.quoteContainer}>
            <FormatQuote className={classes.openQuote} />
            <Typography variant="body1" className={classes.quote}>
              {t('sharedComponents.MortgageSurveyFlowSelect.proofQuote')}
            </Typography>
            <br />
            <Typography variant="h2" className={classes.quoteBy} align="right">
              {t('sharedComponents.MortgageSurveyFlowSelect.proofQuoteBy')}
            </Typography>
            <Typography variant="body2" className={classes.quoteByDesc} align="right">
              {t('sharedComponents.MortgageSurveyFlowSelect.proofQuoteByDesc')}
            </Typography>
          </Box>
        </div>
      )}
    </Box>
  );
};

MortgageSurveyFlowSelect.propTypes = {
  onSelect: PropTypes.func.isRequired,
  rowComponent: PropTypes.node,
  removeQuoteBox: PropTypes.bool,
};

MortgageSurveyFlowSelect.defaultProps = {
  rowComponent: null,
  removeQuoteBox: false,
};

export default MortgageSurveyFlowSelect;



// WEBPACK FOOTER //
// ./src/sharedComponents/MortgageSurveyFlowSelect/MortgageSurveyFlowSelect.js